import Vue from "vue";
import Axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { to } from "./promiseHandle";
import { AuthenService } from '@/services/authen.service.ts';
import store from '@/store/store';
export class CommonService {
  private baseAPI = process.env.VUE_APP_API_URL;
  private commonAPI = process.env.VUE_APP_API_COMMON_URL;
  private authService = new AuthenService();

  constructor() { }

  get headers() {
    return {
      "Content-Type": "application/json",
      auth: localStorage.getItem("token")
    };
  }

  // // ===== Request Method =====

  public async get(url: string, header?: any) {
    return await to(
      Axios.get<AxiosResponse>(url, { headers: { ...this.headers, ...header } })
    );
  }

  public async post(url: string, body: any, header?: any) {
    return await to(
      Axios.post<AxiosResponse>(url, body, {
        headers: { ...this.headers, ...header }
      })
    );
  }

  public async put(url: string, body?: any, header?: any) {
    return await to(
      Axios.put<AxiosResponse>(url, body, {
        headers: { ...this.headers, ...header }
      })
    );
  }

  public async delete(url: string, data?: any) {
    if (data) {
      return await to(
        Axios.delete(url, { headers: { ...this.headers }, data })
      );
    } else {
      return await to(
        Axios.delete(url, { headers: { ...this.headers } })
      );
    }

  }
  // // ===== Request Method =====

  async calcZeinuki(
    priceZk: number,
    taxRate: number | null = 100,
    roundedKbn: number = 0
  ) {
    try {
      const { result } = await this.get(
        `${
        this.commonAPI
        }/tax/shouhizei/calcZeinuki?q=price=${priceZk},taxRate=${taxRate},roundedKbn=${roundedKbn}`
      );
      return result.data.zeinuki;
    } catch (ex) {
      return priceZk;
    }
  }
  async calcZeikomi(
    priceZn: number,
    taxRate: number | null = 100,
    roundedKbn: number = 0
  ) {
    try {
      const { result } = await this.get(
        `${
        this.commonAPI
        }/tax/shouhizei/calcZeikomi?q=price=${priceZn},taxRate=${taxRate},roundedKbn=${roundedKbn}`
      );
      return result.data.zeikomi;
    } catch (ex) {
      return priceZn;
    }
  }

  async getTaxList() {
    const { result, error } = await this.get(`${this.commonAPI}/tax/shouhizei/list`);
    if (result) {
      return result.data;
    } else {
      return this.authService.handleError(error, "getTaxList");
    }
  }

  public async getKyotens() {
    const { result, error } = await this.get(`${this.baseAPI}/kyotens`);
    if (result) {
      return result.data;
    } else {
      return this.authService.handleError(error, "getKyotens");
    }
  }

  public async reqEnvironment(kyotenCd: string) {
    const { result, error } = await this.get(
      `${this.baseAPI}/user/setting/environment?q=kyotenCd=${kyotenCd}`
    );
    if (result) {
      return result.data;
    } else {
      return null;
    }
  }

  public async getEnvironment() {
    let envVal = store.getters["EnvironmentStore/environment"];
    if (envVal) {
      return envVal;
    } else {
      let kyotenCd = localStorage.getItem("kyotenCd");
      if (kyotenCd) {
        const env = await this.reqEnvironment(kyotenCd);
        store.dispatch("EnvironmentStore/setEnvironment", env);
        return env;
      }
    }
  }

  public async getKbnSkns(sknTitle: string, kbnCd?: string) {
    let path = `${this.baseAPI}/kbnskns/${sknTitle}`;
    if (kbnCd) {
      path += "/" + kbnCd;
    }
    const { result, error } = await this.get(path);
    if (result) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getKbnSkns');
      return;
    }
  }

  async getHanyouSeibiVersion(groupCd: any, shatenCd: any, kyotenCd: any) {
    let param = `?groupCd=${groupCd}&shatenCd=${shatenCd}`;
    if (kyotenCd) {
      param += `&kyotenCd=${kyotenCd}`;
    }
    const { result, error } = await this.get(`${this.baseAPI}/admin/master/sknversions${param}`);
    if (result) {
      return result.data;
    } else if (error) {
      return [];
    }
  }

  async getKyotenHasVersion(groupCd: any, shatenCd: any) {
    const param = `?q=groupCd=${groupCd},shatenCd=${shatenCd}`;
    const { result, error } = await this.get(`${this.baseAPI}/admin/master/kyotens-has-version${param}`);
    if (result && result.data) {
      return result.data;
    }
    return [];
  }
}
